import request from '@/request'

const Dashboard = {
  state: {
    dataSummaryLog: []
  },
  mutations: {
    GET_SUMMARY_LOG (state, data) {
      state.dataSummaryLog = data
    }
  },
  actions: {
    async getSummaryLog({ commit },payload) {
      const accessToken = localStorage.getItem('access_token')
      let response = { code: 'init', massage: null }
      await request({
        method: "POST",
        url: process.env.VUE_APP_API_GET_SUMMARY_LOG,
        data: payload,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken
        }
      }).then((res) => {
        console.log("response", res);
        response.status = res.responseCode
        response.massage = res.responseMessage
        commit('GET_SUMMARY_LOG', res)
      }).catch(error => {
        console.error('res error >>>', error, error.response)
        response.code = error.response.status
        response.massage = error.response.statusText
      })
      return response
    }
  },
  getters: {
    dataSummaryLog (state) {
      return state.dataSummaryLog
    }
  }
}
export default Dashboard